import React, {useEffect, useState} from 'react';
import {TextField} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import {useRecoilValue} from "recoil/dist";
import {answersState} from "../../../../states/test_progress_states";
import {getNewSelectedAnswers, getQuestionAnswers} from "../../../../helpers/QuestionHelper";
import withQuestionLogic from "../../../HOC/withQuestionLogic";
import {handleFocusTextInput} from "../../../../helpers/handleFocusTextInput";

const TextInputQuestion = ({question, selectAnswer, markNextAble}) => {
    const answers = useRecoilValue(answersState);
    const [studentAnswers, setStudentAnswers] = useState([]);
    let idTextAnswer = `idTextAnswer${question.questionCode}`;
    let textAnswer = localStorage.getItem(idTextAnswer) ? localStorage.getItem(idTextAnswer) : '';

    const [keyword, setKeyWord] = useState(textAnswer);

    useEffect(() => {
        setStudentAnswers(getQuestionAnswers(question, answers));
        answers.forEach( (answer) => {
            if(answer.questionCode === question.questionCode && answer.text !== ""){
                setKeyWord(answer.text);
            }
        });
    }, []);

    useEffect(() => {
        if (keyword) {
            localStorage.setItem(idTextAnswer, keyword);
            markNextAble(true);
        } else {
            localStorage.removeItem(idTextAnswer);
            markNextAble(false);
        }
    }, [keyword]);

    const handleChange = (event) => {
        setKeyWord(event.target.value);
        selectAnswer(question.questionCode, getNewSelectedAnswers(question, 0, studentAnswers, event.target.value));
        if(event.target.value){
            markNextAble(true);
        }
    };

    return (
        <React.Fragment>
            <TextField
                onFocus={handleFocusTextInput}
                id={idTextAnswer}
                fullWidth
                margin="normal"
                variant="outlined"
                size="small"
                autoComplete="off"
                value={keyword}
                onChange={handleChange}
                InputProps={{
                    endAdornment: <ClearIcon onClick={() => {
                        setKeyWord('');
                    }}/>,
                }}
            >
            </TextField>
        </React.Fragment>
    );
};

export default withQuestionLogic(TextInputQuestion);
